export enum MODAL_SIZING_ONE_COLUMN_REDUCE {
  WIDHT = '90%',
  MAX_WIDTH = '400px',
  HEIGHT = 'auto',
}

export enum MODAL_SIZING_ONE_COLUMN {
  WIDHT = '90%',
  MAX_WIDTH = '500px',
  HEIGHT = 'auto',
}

export enum MODAL_SIZING_TWO_COLUMNS {
  MIN_WIDTH = '450px',
  WIDHT = '90%',
  MAX_WIDTH = '800px',
  HEIGHT = 'auto',
  MAX_HEIGHT = '800px',
}

export enum MODAL_SIZING_TWO_COLUMNS_REDUCE {
  WIDHT = '90%',
  MAX_WIDTH = '650px',
  HEIGHT = 'auto',
}

export enum MODAL_SIZING_THREE_COLUMNS {
  WIDHT = '90%',
  MAX_WIDTH = '1200px',
  MIN_WIDTH = '450px',
  HEIGHT = 'auto',
}

export enum MODAL_SIZING_EMAILS {
  WIDHT = '90%',
  MAX_WIDTH = '500px',
  HEIGHT = 'auto',
}

export enum MODAL_SIZING_CLOSING_DATE {
  WIDHT = '75%',
  MAX_WIDTH = '400px',
  MIN_WIDTH = '370px',
  HEIGHT = 'auto',
}


export enum MODAL_MASSIVE_REQUEST_THREE{
  WIDHT = '90%',
  MAX_WIDTH = '650px',
  HEIGHT = 'auto',
  MAX_HEIGHT = '1500px',


}

export enum MODAL_CERTIFICATE_TWO_COLUMN {
  WIDHT = '80%',
  MIN_WIDTH = '500px',
  MAX_WIDTH = '600px',
  HEIGHT = 'auto',
  //MAX_HEIGHT = '800px',
}

export enum MODAL_CERTIFICATE_ONE_COLUMN {
  WIDHT = '90%',
  MIN_WIDTH = '520px',
  MAX_WIDTH = '650px',
  HEIGHT = 'auto',
  MAX_HEIGHT = '90vh',
}

export enum MODAL_EVALUATION_TWO_COLUMN {
  WIDHT = '80%',
  MIN_WIDTH = '500px',
  MAX_WIDTH = '600px',
  HEIGHT = 'auto',
  //MAX_HEIGHT = '800px',
}

export enum MODAL_EDITEVALUATION_TWO_COLUMNS {
  MIN_WIDTH = '450px',
  WIDHT = '90%',
  MAX_WIDTH = '850px',
  HEIGHT = 'auto',
  MAX_HEIGHT = '800px',
}



